import React from "react";

interface TotalBalanceProps {
    totalBalance: number; // Prop type for totalBalance
}

const TotalBalance: React.FC<TotalBalanceProps> = ({ totalBalance }) => {
    return (
        <div className={"py-8"}>
            <div className="p-4 flex justify-end items-center border-b dark:border-gray-700">
                  <span className="text-lg font-semibold text-gray-700 dark:text-gray-300">
                    Total Balance: <span>${totalBalance.toFixed(2)}</span>
                  </span>
            </div>
        </div>
    );
};

export default TotalBalance;